import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import AuthContext from "./contexts/AuthContext";
import LandingPage from "./pages/LandingPage";
import StudiosPage from "./pages/StudiosPage.js";
import EventsPage from "./pages/EventsPage.js";
import Login from "./pages/Auth/Login";
import Signup from "./pages/Auth/Signup";
import { JobPostings } from "./components/JobPostings";

export default function AppRouter() {
  const { user } = useContext(AuthContext);

  return (
    <Router>
      <Routes>
        {/* Landing Page - always accessible */}
        <Route path="/" element={<LandingPage />} />

        {/* Public Routes */}
        <Route
          path="/login"
          element={!user ? <Login /> : <Navigate to="/" />}
        />
        <Route
          path="/signup"
          element={!user ? <Signup /> : <Navigate to="/" />}
        />

        {/* Protected Routes */}
        <Route
          path="/works"
          element={user ? <JobPostings /> : <Navigate to="/login" />}
        />
        <Route
          path="/studios"
          element={user ? <StudiosPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/events"
          element={user ? <EventsPage /> : <Navigate to="/login" />}
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}
